var App = App || {};

App.Testimonials = (function ($) {
    "use strict";

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                var $this = $(this),
                    carousel = $this.find(".splide"),
                    controls = $this.find(".controls");

                if (carousel.length) {
                    Carousel(carousel, controls);
                }
            });
        }
    }

    function Carousel(carousel, controls) {
        const splide = new Splide(carousel[0], {
            arrows: false,
            autoplay: true,
            interval: 12000,
            pagination: false,
            type: "loop"
        });

        var $control = $(controls).find(".btn");

        $.each($control, function (index) {
            var $this = $(this);

            $this
                .on("focus focusin mouseover", function () {
                    splide.Components.Autoplay.pause();
                })
                .on("blur focusout mouseout", function () {
                    splide.Components.Autoplay.play();
                })
                .on("click", function (e) {
                    e.preventDefault();

                    splide.go(index);
                });
        });

        // Apply proper role attributes for list items
        // https://github.com/Splidejs/splide/issues/825#issuecomment-2365324992
        splide.on("mounted", function () {
            let $slides = carousel.find(".splide__slide");
            let $slideList = carousel.find(".splide__list");

            $slides
                .removeAttr("role")
                .attr("role", "listitem");

            if ($slideList.length) {
                $slideList
                    .removeAttr("role")
                    .attr("role", "list");
            }
        });

        splide.on("mounted move", function () {
            var $control = $(controls).find(".btn");

            $.each($control, function () {
                var $this = $(this);

                $this.removeClass("active");
                $($control[splide.index]).addClass("active");

                if (splide.Components.Autoplay.isPaused()) {
                    $($control[splide.index]).addClass("stop");
                }
                else {
                    $($control[splide.index]).removeClass("stop");
                }
            });
        });

        splide.mount();

        splide.on("autoplay:play", function () {
            $(controls)
                .find(".btn.active")
                .removeClass("stop");
        });

        splide.on("autoplay:pause", function () {
            $(controls)
                .find(".btn.active")
                .addClass("stop");
        });
    }

    return {
        Init: Init
    };
})(jQuery);